export default __webpack_public_path__ + "media/images/django_logo-2dd7b4bf.svg";